<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{ this.getLanguage["MAPP"][obj_ab.I > 0? "EMBA": "AMBA"] }}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{ this.getLanguage["MAPP"]["BN"] }}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                        :options="dd_agentgroup"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        :clearable="false"
                                                        :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                        v-model="obj_ab['AGIT']"
                                                        @input="AgentGroupChange"
                                                        :disabled="obj_ab.I > 0"
                                                        ref="AGIT" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{ this.getLanguage["MAPP"]["AN"] }} <span class="required" /> :</label>
                                            <CInput size="sm" :value="obj_ab.AN" placeholder="" @change="v => obj_ab.AN = v" :disabled="obj_ab['AN'] == 0" ref="AN" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('AN','AN') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{ this.getLanguage["MAPP"]["API"] }}<span class="required" /> :</label>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <img v-if="obj_ab['I'] > 0"
                                                 width="auto"
                                                 height="150"
                                                 class="mb-2"
                                                 :src="getImgUrl(obj_ab['IU'])" />
                                            <div class="custom-file">
                                                <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onFileSelected" required>
                                                <label class="custom-file-label" for="validatedCustomFile" v-if="selectedFile === null">{{ getLanguage['CTAB']['CAI'] }}.</label>
                                                <label class="custom-file-label" for="validatedCustomFile" v-else>{{ selectedFile.name }}</label>
                                                <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                            </div>
                                            <label class="col-form-label-sm">{{ getLanguage["RIZ"]["IZ"] }} : 800 x 800</label>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveAppRequest()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ this.getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{ this.getLanguage['MANDATORY']['FIELDS'] }}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_fullPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd1">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <img :src="previewUrl" class="img-fluid" v-if="previewUrl">
                                    <p v-else>{{this.getLanguage['GL']['NR']}}</p>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class="pageHeader position-relative">
                        <h2 id="titleHeight">{{ this.getLanguage["MAPP"]["MA"] }}</h2>
                        <CButton size="sm"
                                 color="outline-info"
                                 @click="addMobileApp()"
                                 v-if="checkModuleAccess2(constAccessType.add)"
                                 data-toggle="notificationAddmodal"
                                 data-target="#myModal">
                            <span class="plusIcon cil-plus"></span>
                            {{ this.getLanguage["MAPP"]["ANA"] }}
                        </CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class="searchBox">
                            <div class='searchCol' style="width: 200px">
                                <span class='searchLabel'>{{ this.getLanguage["AN"]["BN"] }} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroup"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MAPP"]["RSD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[3].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[3].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[3].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MAPP"]["RED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[3].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[3].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[3].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class="searchCol">
                                <span class="searchLabel">{{ getLanguage["MAPP"]["RS"] }} :</span>
                                <treeselect :multiple="false"
                                            :options="RequestStatus"
                                            placeholder
                                            v-model="str_FV[5].FV" />
                            </div>
                        </div>
                        <div class="searchBtnCol">
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class="searchBtn" size="sm" block color="success" @click="newSearch()">
                                <span class="searchIcon cil-search"></span>
                                <span>{{ getLanguage["BTN"]["SR"] }}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class="table-wrapper">
                <header class="table-header">
                    <strong>{{ getLanguage["MAPP"]["MAPPL"] }}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{ int_TP }}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class="custom-table afb-blue">
                        <thead>
                            <tr>
                                <th>{{ getLanguage["GL"]["NO"] }}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{ getLanguage["GL"]["ACT"] }}</th>
                                <th>{{ getLanguage["MAPP"]["BN"] }} <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["MAPP"]["RS"] }} <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["MAPP"]["API"] }} </th>
                                <th>{{ getLanguage["MAPP"]["AN"] }} <i @click="setSortTable('AN')" :class="setSortLogo('AN')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["MAPP"]["RB"] }} <i @click="setSortTable('CB')" :class="setSortLogo('CB')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["MAPP"]["RD"] }} <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["MAPP"]["LUD"] }} <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class="custom-table afb-blue">
                        <thead>
                            <tr>
                                <th>{{ getLanguage["GL"]["NO"] }}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{ getLanguage["GL"]["ACT"] }}</th>
                                <th>{{ getLanguage["MAPP"]["BN"] }} <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["MAPP"]["RS"] }} <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["MAPP"]["API"] }} </th>
                                <th>{{ getLanguage["MAPP"]["AN"] }} <i @click="setSortTable('AN')" :class="setSortLogo('AN')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["MAPP"]["RB"] }} <i @click="setSortTable('CB')" :class="setSortLogo('CB')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["MAPP"]["RD"] }} <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["MAPP"]["LUD"] }} <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_bl.length == 0">{{ this.getLanguage['GL']['NR'] }}</td>
                        <tr v-for="(data,index) in arry_bl">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                <span id="actionBtnCol">
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.delete)">
                                        <i class="cil-trash" @click="removeRequest(data)"></i>
                                        <span class="custom-tooltiptext">{{ getLanguage["BTN"]["DLT"] }}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit)">
                                        <i class="cil-color-border" @click="editMobileApp(data.I)"></i>
                                        <span class="custom-tooltiptext">{{ getLanguage["BTN"]["ED"] }}</span>
                                    </div>
                                </span>
                            </td>
                            <td>
                                <span>
                                    {{ data.GN }} ({{ data.PC }})
                                </span>
                            </td>
                            <td v-if="checkModuleAccess2(constAccessType.edit) && checkRequestStatus(data.RS)">
                                <CDropdown :ref="'dd_status_' + index"
                                           :toggler-text="renderStatus(data.RS)"
                                           :color="renderStatusColor(data.RS)"
                                           size="sm"
                                           class="m-1 d-inline-block">
                                    <CDropdownItem @click="changeStatus(2,data,index)">{{ getLanguage['GL']['APR'] }}</CDropdownItem>
                                    <CDropdownItem @click="changeStatus(3,data,index)">{{ getLanguage['GL']['REJ'] }}</CDropdownItem>
                                </CDropdown>
                            </td>
                            <td v-else>
                                <span :class="renderStatusColorText(data.RS)">{{ renderStatus(data.RS)}}</span>
                            </td>
                            <td>
                                <a href="javascript:void(0)" style="color:blue" @click="setPreview(data.IU)">
                                    <u>{{getLanguage["GL"]["P"]}}</u>
                                </a>
                            </td>
                            <td>{{ data.AN }}</td>
                            <td>{{ data.CB }}</td>
                            <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from "vue2-daterange-picker";
    import Treeselect from "@riophae/vue-treeselect";
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import moment from "moment";
    import "@riophae/vue-treeselect/dist/vue-treeselect.css";
    import { mapGetters, mapActions } from "vuex";
    import Loading from "vue-loading-overlay";
    import genericHelper from "@/modules/GenericHelper.js";
    import { parse } from "semver";
    import { required } from "vuelidate/lib/validators";
    import { loadingFullScreen, constAccessType, constRequestStatus, constRejectReasonApp } from '@/modules/Constant.js';
    import Axios from "axios";
    import Vue from 'vue';
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                selectedFile: null,
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false, //Loading Visible,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_fullPreview: false,
                bool_showSearchBar: true,
                newImg: false,
                str_FV: [
                    { F: "AGI" },
                    { F: "DI" },
                    { F: "DT_csv", FA: true },
                    {
                        F: "STS", FV: {
                            startDate: "",
                            endDate: ""
                        }
                    },
                    { F: "L_csv", FA: true },
                    { F: "RS" },
                ], //Filter Value
                obj_ab: {
                    I: 0,
                    RS: null,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    IU: "",
                    AGI: 0,
                    AGIT: null,
                    AN: null,
                    appIcon: null
                },
                arry_DT: [],
                int_TP: 1,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_RC: 0,
                int_Total: 0,
                str_tableSortBy: "UTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                int_lblPage: 1, //Hold the label value, default is 1
                str_imgURL: "",
                arry_bl: [],
                currentindex: -1,
                constAccessType: constAccessType,
                dd_pt: [{ id: '0', label: 'System Page' }, { id: '1', label: 'Promotion Page' }, { id: '2', label: 'Static Page' }], // page type
                dd_spt: [], //System Page Type
                dd_do: [], // Domain Option
                RequestStatus: [],
                dd_agentgroup: [],
                dd_dofs: [],
                dd_gp: null,
                domainUrl: null,
                pageUrlAllow: false,
                excludeId: ['0', '100', '101', '102', '103'],
                previewUrl: null,
            };
        },
        validations: {
            obj_ab: {
                AGIT: { required },
                AN: { required }
            }
        },
        computed: {
            ...mapGetters("Language", ["getLanguage"]),
            ...mapGetters('UserInfo', ['checkModuleAccess']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo'])
        },
        created() {
            this.$parent.showSubMenu = "MAPP";
            this.$parent.showActiveMenu = "MAPP.MAPPL";
            this.getRequestStatus();
            this.maxList();
            this.getMobileList();
            this.getAgentGroup();

            //setTimeout(() => {
            //    $(".custom-tooltip").hover(function () {
            //        $(".table-wrapper .custom-table-wrapper").css("overflow", "initial")
            //    }, function () {
            //        $(".table-wrapper .custom-table-wrapper").css({ "overflow": "auto", "overflow-y": "hidden" });
            //    }
            //    );
            //}, 300)
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getMobileList();
                this.getRequestStatus();
            },
        },
        methods: {
            maxList() {
                var num = this.getMaxDisplayPerList();
                this.int_RC = num;
            },
            DownloadAppIcon(url) {
                window.open(url, '_blank');
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[3].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[3].FV.endDate = "";
                    }
                }
            },
            rurlType() {
                var result = 0;
                if (this.obj_ab.AT == 0) {
                    result = 0;
                }
                else {
                    if (this.obj_ab.PT != null) {
                        result = 0;
                    }
                    else {
                        result = 2;
                    }
                }
                return result;
            },
            changeStatus(statusSelect, d, index) {

                this.$fire({
                    title: this.getLanguage["GL"]["CM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {

                        this.bool_fullLoading = true;
                        var that = this;

                        var dt = {
                            I: d.I,
                            RS: statusSelect
                        };
                        this.postDataApi(`/api/mapp/us`, dt, function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.selectedFile = null;
                                that.getMobileList();
                            }
                        });
                    }
                });

                //if (statusSelect == 2) {

                //} else {
                //    this.obj_ad = Object.assign({}, d);
                //    this.dd_rejectreason = constRejectReasonApp;
                //    this.obj_Reject = {
                //        reason: null,
                //        reason2: ""
                //    };
                //}
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('MAPPL', 'MAPP', type);
            },
            checkRequestStatus(status) {
                if (status == 1) {
                    return true;
                }
            },
            ClearDD(value) { //here clear option and select
                this.dd_gp = null;
                this.obj_ab.GPRVD = null;
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (this.getUserInfo.AT == 0 && agi[0] == "0") {
                    item.isDisabled = false;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                    }
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                                that.str_FV[0].FV = agi;
                            }
                        });
                }
                else {
                    this.str_FV[0].FV = null;
                }
            },
            AgentGroupChange(value) {
                if (this.obj_ab['I'] == 0) {
                    this.obj_ab['DI'] = null;
                }
                var that = this;
                var agi = 0;

                if (value != "") {
                    agi = value.split("-")[1];
                    this.obj_ab.AT = value.split("-")[0];
                }

                this.getDataApi(`/api/dd/dn/` + agi,
                    function (d, s) {
                        if (s) {
                            that.dd_do = d.dropdownlist
                        }
                    });
            },
            getRequestStatus() {
                this.RequestStatus = [{
                    id: "1",
                    label: this.getLanguage['DB']['AC1']
                }, {
                    id: "2",
                    label: this.getLanguage['DB']['AC2']
                }, {
                    id: "3",
                    label: this.getLanguage['DB']['AC3']
                }];
            },
            onFileSelected(event) {
                this.obj_ab['IU'] = null;
                this.selectedFile = this.validateFile(event);
                this.newImg = true;
            },
            closeAdd() {
                this.selectedFile = null;
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            closeAdd1() {
                this.previewUrl = null;
                this.bool_fullPreview = !this.bool_fullPreview;
            },
            setSortTable(SV) {
                //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort; //change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getMobileList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF
                    ? this.bool_isSort
                        ? "sort-descending"
                        : "sort-ascending"
                    : "list"
                    }`; //here change the sort logo
            },
            addMobileApp() {
                this.obj_ab = {
                    I: 0,
                    RS: null,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    IU: "",
                    AGI: 0,
                    AGIT: null,
                    AN: null,
                    appIcon: null
                };
                this.arry_type = [];
                this.bool_isAMV = true;
                this.bool_CV = false;
                this.newImg = false;

                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.obj_ab.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_ab.AGIT);
                    }
                }
            },
            returnRS() {
                if (this.obj_ab["RS"] == true) {
                    return 2;
                } else {
                    return 1;
                }
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_ab[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MAPP"][langKey]);
                    }
                }

            },
            saveAppRequest() {
                this.bool_CV = true;
                //clear un-used data
                //var rurlTab = this.getRURLTabIndex();

                if (this.obj_ab.AT == 0) {
                    this.obj_ab['DI'] = 0;
                }

                //get image url type
                if (this.obj_ab.IU != null && this.obj_ab.IU != "") {
                    //if img url is not empty
                    this.obj_ab.IUT = true;
                    this.newImg = true;
                }

                //validate data required
                this.$v.obj_ab.$touch();
                if (!this.$v.obj_ab.$error) {

                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;

                    if (this.obj_ab.AGIT != null && this.obj_ab.AGIT.length > 0) {
                        var agi = this.obj_ab.AGIT.split("-");
                        this.obj_ab.AGI = agi[1];
                    }

                    //get rs
                    this.obj_ab.RS = this.returnRS();

                    var that = this;
                    if (this.newImg == true) {
                        //if new image is selected
                        that.obj_ab["appIcon"] = that.selectedFile;
                        this.postDataApiWithAttach(`/api/mapp/s`, this.obj_ab, function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.selectedFile = null;
                                that.getMobileList();
                            }
                        });
                    } else if (this.newImg == false && this.obj_ab["I"] > 0) {
                        that.obj_ab["appIcon"] = null;
                        //if user edit, but want to retain image
                        this.postDataApiWithAttach(`/api/mapp/s`, this.obj_ab, function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.selectedFile = null;
                                that.getMobileList();
                            }
                        });
                    } else {
                        that.bool_fullLoading = false;
                        that.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.4002")));
                    }
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_ab"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
                //clear un-used data
            },
            getMobileList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(
                    this.int_Page,
                    this.int_RC,
                    this.str_tableSortBy,
                    this.bool_isSort
                );

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                var split = this.str_FV[i].FV[x].split("-");

                                if (split.length == 2) {
                                    temp_ += split[1];
                                }
                                else {
                                    temp_ += split[0];
                                }
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'STS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "" && this.str_FV[i].FV.endDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);

                                var full = cts_from + "," + cts_to;
                                path += ("f[STS_drsft]=" + full + "&f[ETS_dreft]=" + full);
                            }
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                this.getDataApi(`/api/mapp/l?${path}`, function (d, s) {
                    if (s) {
                        that.bool_fullLoading = false;
                        that.setMobileAppList(d.D);
                        that.resizeTableHead();
                    }
                });
            },
            setMobileAppList(data) {                
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_Total = data.TotalItems;
                this.arry_bl = data.Items;
            },
            setMobileApp(data) {

                this.obj_ab = Object.assign(this.obj_ab, data);

                if (data.RS == 2) {
                    this.obj_ab.RS = true;
                }
                else {
                    this.obj_ab.RS = false;
                }

                if (this.obj_ab.AGI != 18) {
                    this.obj_ab.AGIT = "3-" + this.obj_ab.AGI;
                    this.AgentGroupChange(this.obj_ab.AGIT);
                }
                else if (this.obj_ab.AGI == 18) {
                    this.obj_ab.AGIT = "0-" + this.obj_ab.AGI;
                    this.obj_ab.AT = 0;
                    this.AgentGroupChange(this.obj_ab.AT);
                }

                this.bool_isAMV = true;

            },
            editMobileApp(id) {
                this.bool_fullLoading = true;
                this.newImg = false;
                var that = this;
                this.getDataApi(`/api/mapp/g/${id}`, function (d, s) {
                    that.bool_fullLoading = false;
                    if (s) {
                        that.setMobileApp(d.D);
                    }
                });
            },
            removeRequest(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS
                        };

                        this.postDataApi(`/api/mapp/d`, dt, function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.getMobileList();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                        });
                    }
                });
            },
            renderStatus(int_status) {
                switch (int_status) {
                    case 2:
                        return this.getLanguage["GL"]["APRD"];
                        break;
                    case 3:
                        return this.getLanguage["GL"]["REJD"];
                        break;
                    default:
                        return this.getLanguage["GL"]["PEND"];
                        break;
                }
            },
            renderStatusColor(int_status) {
                switch (int_status) {
                    case 2:
                        return "success";
                        break;
                    case 3:
                        return "danger";
                        break;
                    default:
                        return "primary";
                        break;
                }
            },
            renderStatusColorText(int_status) {
                switch (int_status) {
                    case 2:
                        return "text-success";
                        break;
                    case 3:
                        return "text-danger";
                        break;
                    default:
                        return "text-primary";
                        break;
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getMobileList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getMobileList();
                }
            },
            clearDateRangeFilter() {
                this.str_FV[3].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            setPreview(value) {
                this.previewUrl = value;
                this.bool_fullPreview = true;
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        }
    };
</script>

<style>
    .a {
        color: blue !important;
        cursor: pointer;
    }

    .tab-content .tab-pane {
        padding: 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/MobileApp/MobileAppList.vue